import { render, staticRenderFns } from "./CopyrightMessagesEscalated.vue?vue&type=template&id=7d096313&scoped=true&"
import script from "./CopyrightMessagesEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightMessagesEscalated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d096313",
  null
  
)

export default component.exports